<template>
  <div id="login">
    <div class="login-wrap">
      <FormAuth :user="user" :err="err" @login="login" @clear-err="err = []" />
    </div>
  </div>
</template>

<script>
import api from "@/api/user";
import FormAuth from "../components/Authentification/FormAuth";

export default {
  name: "Authentification",
  components: { FormAuth },
  data() {
    return {
      user: { email: "", password: "" },
      err: [],
    };
  },
  methods: {
    login() {
      this.err = [];
      if (!this.user.email && !this.user.password) {
        this.err.push("Les champs ne peuvent pas être vides");
        return;
      }
      if (!this.user.email) {
        this.err.push("L'identifiant ne peut pas être vide");
        return;
      }
      if (!this.user.password) {
        this.err.push("Le mot de passe ne peut pas être vide");
        return;
      }
      api.login(this.user)
        .then((res) => {
          this.$store.commit("infosUser", res.data.data);
          this.$router.push({ name: "home" });
        })
        .catch((error) => {
          if (error.response) {
            const msg = error.response?.data?.message;
            this.err.push(msg || "Identifiant ou mot de passe incorrect");
          } else {
            this.err.push("Impossible de contacter le serveur. Vérifiez votre connexion.");
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
#login {
  min-height: 100vh;
  background: linear-gradient(160deg, #f3f2f0 55%, #e1edf2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-wrap {
  width: 100%;
  max-width: 440px;
  padding: 16px;
}
</style>
